import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type Batch,
  type CreateBatchParams,
} from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const createBatch = createAsyncThunk<
  Batch,
  CreateBatchParams,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CREATE_BATCH, async (params, { extra }) => {
  return await extra.batchesRepo.createBatch(params);
});
